import { z } from "zod";
import { BillingOrderItemSchema } from "./billing-order-item";
import { ResultDataSchema } from "../result-data/result-data";

export const BillingOrderResultSchema = ResultDataSchema.extend({
  Results: BillingOrderItemSchema.array(),
});

export type BillingOrderResultType = z.infer<typeof BillingOrderResultSchema>;
